import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Grid
} from '@mui/material';
import api from '../../utils/api';

const SupplierDialog = ({ open, onClose, onSave, initialData }) => {
  const [saving, setSaving] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    vatNumber: '',
    fiscalCode: '',
    address: '',
    city: '',
    postalCode: '',
    province: '',
    country: 'Italia',
    phone: '',
    email: '',
    pec: '',
    sdiCode: '',
    notes: ''
  });

  useEffect(() => {
    if (open) {
      if (initialData) {
        setFormData({
          name: initialData.name || '',
          vatNumber: initialData.vatNumber || '',
          fiscalCode: initialData.fiscalCode || '',
          address: initialData.address || '',
          city: initialData.city || '',
          postalCode: initialData.postalCode || '',
          province: initialData.province || '',
          country: initialData.country || 'Italia',
          phone: initialData.phone || '',
          email: initialData.email || '',
          pec: initialData.pec || '',
          sdiCode: initialData.sdiCode || '',
          notes: initialData.notes || ''
        });
      } else {
        setFormData({
          name: '',
          vatNumber: '',
          fiscalCode: '',
          address: '',
          city: '',
          postalCode: '',
          province: '',
          country: 'Italia',
          phone: '',
          email: '',
          pec: '',
          sdiCode: '',
          notes: ''
        });
      }
    }
  }, [open, initialData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    if (!formData.name.trim()) return;
    setSaving(true);
    try {
      const isEdit = initialData && initialData.id;
      const res = isEdit
        ? await api.put(`/suppliers/${initialData.id}`, formData)
        : await api.post('/suppliers', formData);
      onSave(res.data);
      onClose();
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{initialData && initialData.id ? 'Modifica fornitore' : 'Nuovo fornitore'}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 0.5 }}>
          <Grid item xs={12}>
            <TextField name="name" label="Ragione sociale *" fullWidth value={formData.name} onChange={handleChange} required />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField name="vatNumber" label="Partita IVA" fullWidth value={formData.vatNumber} onChange={handleChange} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField name="fiscalCode" label="Codice fiscale" fullWidth value={formData.fiscalCode} onChange={handleChange} />
          </Grid>
          <Grid item xs={12}>
            <TextField name="address" label="Indirizzo" fullWidth value={formData.address} onChange={handleChange} />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField name="city" label="Città" fullWidth value={formData.city} onChange={handleChange} />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField name="postalCode" label="CAP" fullWidth value={formData.postalCode} onChange={handleChange} />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField name="province" label="Provincia" fullWidth value={formData.province} onChange={handleChange} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField name="phone" label="Telefono" fullWidth value={formData.phone} onChange={handleChange} />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField name="email" label="Email" fullWidth type="email" value={formData.email} onChange={handleChange} />
          </Grid>
          <Grid item xs={12}>
            <TextField name="notes" label="Note" fullWidth multiline rows={2} value={formData.notes} onChange={handleChange} />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Annulla</Button>
        <Button variant="contained" onClick={handleSubmit} disabled={saving || !formData.name.trim()}>
          {saving ? 'Salvataggio...' : 'Salva'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SupplierDialog;
